module.exports = __webpack_public_path__ + "static/img/hangye_5@2x.69290eec.png";